import { RichTextHorizontalRuleBlockNode } from '@cinemark/content-api-client';
import type { SerializedBlockNode } from '@payloadcms/richtext-lexical';

type RichTextHorizontalRuleBlockComponentProps = {
  node: SerializedBlockNode | undefined;
};

export const RichTextHorizontalRuleBlockComponent = ({ node }: RichTextHorizontalRuleBlockComponentProps): React.JSX.Element | null => {
  if (!node || node.type !== 'block' || !node.fields || typeof node.fields !== 'object' || node.fields.blockType !== 'horizontalRule') return null;

  const fields = node.fields as unknown as RichTextHorizontalRuleBlockNode;
  const height = `${fields.thickness || 1}px`;

  const getGradientStyle = (): React.CSSProperties => {
    const startColor = fields.startColor || 'transparent';
    const endColor = fields.endColor || 'transparent';
    const viaColor = fields.viaColor;

    if (fields.gradientType === 'radial') {
      const colors = viaColor ? `${startColor}, ${viaColor}, ${endColor}` : `${startColor}, ${endColor}`;
      return {
        backgroundImage: `radial-gradient(${colors})`,
        height,
      };
    }

    let direction = 'to right';
    switch (fields.gradientDirection) {
      case 'to-left':
        direction = 'to left';
        break;
      case 'to-top':
        direction = 'to top';
        break;
      case 'to-bottom':
        direction = 'to bottom';
        break;
      default:
        direction = 'to right';
        break;
    }

    const colors = viaColor ? `${startColor}, ${viaColor}, ${endColor}` : `${startColor}, ${endColor}`;
    return {
      backgroundImage: `linear-gradient(${direction}, ${colors})`,
      height,
    };
  };

  if (fields.style === 'solid' || !fields.style) {
    return (
      <hr style={{ height }} />
    );
  }

  return (
    <hr className="border-0"
      style={getGradientStyle()}
    />
  );
};
